import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { SearchBar } from '@sections/shared/SearchBar';
import { GridView, RecommendProducts, StoreFront } from '@sections/shared/GridView';
import { StyledFlex, StyledSection, StyledTextPairing } from './ShopSection.styles';

interface ShopSectionProps {
  products: RecommendProducts;
  idPrefix: string;
  shopSearchData: Record<string, string>;
}
export const ShopSection = ({ products, shopSearchData, idPrefix }: ShopSectionProps) => {
  return (
    <StyledSection as="section" id={`${idPrefix}ShopSection`} marginTop={6}>
      <Flex margin={'auto'} flexDirection="column" paddingX={[3, 0]} alignItems="center">
        <StyledTextPairing
          alignment={'center'}
          title={shopSearchData.title}
          titleTagName={'h2'}
          titleColor={'neutra6'}
          titleVariant={'hed56'}
          body={ReactHtmlParser(shopSearchData.subTitle)}
          bodyColor={'neutra5'}
          bodyVariant={'dek24'}
          marginBottom={7}
        />
        <StyledFlex>
          <SearchBar
            submitLabel={shopSearchData.submitLabel}
            placeHolder={shopSearchData.placeholder}
            eventName="RegistrySearched"
            id={idPrefix}
          />
        </StyledFlex>
      </Flex>
      <Box marginY={[9, 10]} paddingY={[0, 3]}>
        <GridView items={products} itemPerLine={{ sm: 4, belowSm: 2 }} eventName={'ShopItemClicked'} storeFront={StoreFront.wedding} />
      </Box>
    </StyledSection>
  );
};
